const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '答疑澄清情况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]
const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/gt-jy-zhaobiao/api/dycq/startCQ.do`, {
                bdGuid: this.form.bdGuid,
                guids: this.form.cqwtGuid,
                cqType: this.$route.query.id,
                cqStage: this.form.cqStage,
            }).then((res) => {
                this.config[1].options.data = {
                    '标段名称': res.data.ggName,
                    '标段编号': res.data.bdBH,
                }
                this.config[3].options.data = {
                    '答疑澄清标题': res.data.dycqTitle,
                    '澄清类型': res.data.cqType,
                    '答疑澄清内容': res.data.dycqContent,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
